<template>
  <v-app>

    <portal-sysbar></portal-sysbar>

    <div class="main-content">

      <portal-aside></portal-aside>

      <portal-title :title="$t('message.aside.infoloc', { value: 'default' })"></portal-title>

      <portal-breadcumb></portal-breadcumb>

      <div class="content">
        <v-row>
          <v-col class="d-flex" cols="12" sm="4" md="3">
            <v-autocomplete :items="ecmList"  outlined dense hide-details solo item-value="company"
              item-text="name" label="ECM"  @change="filterByEcm"></v-autocomplete>
          </v-col>
          <v-col class="d-flex" cols="12" sm="4" md="3">
            <v-autocomplete v-model="selectedAsset" :items="assetList" item-value="asset" 
            item-text="asset" :label="$t('message.infoloc.locomotive', { value: 'default' })"
              outlined dense hide-details solo @change="loadData"></v-autocomplete>
          </v-col>


        </v-row>

        <h1>
          <span>{{
            $t("message.infoloc.locomotive", { value: "default" })
          }}</span>
          : {{ asset?.asset?.assetnum }}
        </h1>
        <v-row>
          <v-col>
            <v-chip v-if="this.lastKM" dark :color="getColor()" @click="goToHistory('kmHistory')"
              style="text-transform: uppercase">
              {{ formatdate(lastKM.readingdate) }} : {{ lastKM.reading }} KM

            </v-chip>
          </v-col>
          <v-col>
            <v-chip v-if="this.lastHM" dark :color="getColor()" @click="goToHistory('hmHistory')"
              style="text-transform: uppercase">
              {{ formatdate(lastHM.readingdate) }} : {{ lastHM.reading }} HM

            </v-chip>
          </v-col>
        </v-row>
        <v-row>
          <v-col>

            <v-card class="mb-3" elevation="0">
              <v-card-title class="portal-deep-blue-bg">
                Master Data
              </v-card-title>

              <v-card-text class="mt-5">
                <v-simple-table class="dp-gray" dense>
                  <template v-slot:default>
                    <thead></thead>
                    <tbody>
                      <tr>
                        <th class="text-left shrink" colspan="2">Description</th>
                        <td colspan="2">{{ asset?.asset?.description }}</td>
                      </tr>
                      <tr>
                        <th class="text-left shrink" colspan="2">UIC number</th>
                        <td colspan="2">{{ asset?.asset?.uicnumber }}</td>
                      </tr>
                      <tr>
                        <th class="text-left shrink" colspan="2">Manufacturer</th>
                        <td colspan="2">{{ asset?.asset?.manufacturer }}</td>
                      </tr>
                      <tr>
                        <th class="text-left shrink" colspan="2">
                          Date of Manufacture
                        </th>
                        <td colspan="2">
                          {{ formatdate(asset?.asset?.manufacturerDate) }}
                        </td>
                      </tr>
                      <tr>
                        <th class="text-left shrink" colspan="2">Owner</th>
                        <td colspan="2">{{ asset?.asset?.owner }}</td>
                      </tr>
                      <tr>
                        <th class="text-left shrink" colspan="2">Operator</th>
                        <td colspan="2">{{ asset?.asset?.operator?.name }}</td>
                      </tr>
                      <tr>
                        <th class="text-left shrink" colspan="1">ECM 1</th>
                        <td colspan="3">{{ asset?.asset?.ecm1?.name }}</td>
                      </tr>
                      <tr>
                        <th class="text-left shrink" colspan="1">ECM 2</th>
                        <td colspan="3">{{ asset?.asset?.ecm2?.name }}</td>
                      </tr>
                      <tr>
                        <th class="text-left shrink" colspan="1">ECM 3</th>
                        <td colspan="3">{{ asset?.asset?.ecm3?.name }}</td>
                      </tr>
                      <tr>
                        <th class="text-left shrink" colspan="1">ECM 4</th>
                        <td class="text-left" colspan="3">
                          {{ asset?.asset?.ecm4?.name }}
                        </td>
                      </tr>
                      <tr>
                        <th class="text-left shrink" colspan="1">
                          {{ $t("message.infoloc.cert", { value: "default" }) }}
                        </th>
                        <td colspan="3">
                          <span class="mr-2" v-for="item in homologations" :key="item.assetspedid">{{
                            item.assetattrid.description }},
                          </span>
                        </td>
                      </tr>
                    </tbody>
                  </template>
                </v-simple-table>

              </v-card-text>
            </v-card>
          </v-col>
          <v-col>
            <v-card class="mb-6" elevation="0">
              <v-card-title class="portal-deep-blue-bg">
                {{ $t("message.infoloc.infoOp", { value: "default" }) }}
              </v-card-title>
              <v-card-text class="mt-5">
                <v-simple-table class="dp-gray" dense>
                  <template v-slot:default>
                    <thead>

                    </thead>

                    <tbody>

                      <tr>

                        <th class="text-left shrink">

                          {{ $t("message.infoloc.softwareversion", { value: "default", }) }}

                        </th>

                        <td>{{ asset?.asset?.softwareversion }}</td>

                      </tr>

                      <tr>

                        <th class="text-left shrink">

                          {{ $t("message.infoloc.engineeringvariant", { value: "default", }) }}

                        </th>

                        <td>{{ asset?.asset?.engineeringvariant }}</td>

                      </tr>

                      <tr>

                        <th class="text-left shrink">

                          {{ $t("message.page.status", { value: "default" }) }}

                        </th>

                        <td>{{ asset?.asset?.status }}</td>

                      </tr>

                      <tr>

                        <th class="text-left shrink">

                          {{ $t("message.magic.restriction", { value: "default" }) }}

                        </th>
                        <td>{{ remark }}</td>

                      </tr>

                      <tr>

                        <th class="text-left shrink">
                          {{ $t("message.page.locate", { value: "default" }) }}
                        </th>
                        <td>{{ workorder?.location }}</td>
                      </tr>
                      <tr>
                        <th class="text-left shrink">
                          {{ $t("message.infoloc.actWorkorder", { value: "default", }) }}
                        </th>
                        <td>{{ workorder?.description }}</td>
                      </tr>
                      <tr>
                        <th class="text-left shrink">
                          {{ $t("message.infoloc.outPrevDate", { value: "default", }) }}
                        </th>
                        <td>{{ formatdate(workorder?.schedfinish) }}</td>
                      </tr>
                      <tr>

                        <th class="text-left shrink">

                          {{ $t("message.infoloc.unitToGo", { value: "default" }) }}

                        </th>

                        <td>{{ pleft }}</td>

                      </tr>

                      <tr>

                        <th class="text-left shrink">

                          {{ $t("message.infoloc.nextWorkDate", { value: "default", }) }}

                        </th>

                        <td>{{ formatdate(calcduedate) }}</td>

                      </tr>

                    </tbody>
                  </template>
                </v-simple-table>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>

        <v-card class="mb-3">
          <v-card-title class="portal-deep-blue-bg">
            {{ $t("message.infoloc.sr", { value: "default" }) }}
          </v-card-title>
          <v-card-text class="mt-5">
            <v-data-table :items="srs" :headers="headerSrTable" :items-per-page="5" :search="search" dense>
              <template v-slot:top>
                <v-row>

                  <v-col offset-md="8">

                    <v-text-field v-model="search" append-icon="mdi-magnify"
                      :label="$t('message.search', { value: 'default' })" single-line hide-details></v-text-field>

                  </v-col>

                </v-row>
              </template>
              <template v-slot:[`item.reportdate`]="{ item }">
                {{ formatdate(item.reportdate) }}
              </template>
              <template v-slot:[`item.status`]="{ item }">
                {{ getSrStatusText(item.status) }}
              </template>
              <template v-slot:[`item.action`]="{ item }">
                <v-icon @click="showSrDetails(item.ticketid)">

                  mdi-eye</v-icon>
              </template>
            </v-data-table>
          </v-card-text>
        </v-card>

        <v-row>
          <v-col>
            <v-card ref="kmHistory" class="mb-3">
              <v-card-title class="portal-deep-blue-bg">
                {{ $t("message.infoloc.hkm", { value: "default" }) }}
                <v-col align="right" class="py-0">
                  <vue-excel-xlsx :data="meterKMdatas" :columns="getExportColumns" :file-name="'history_KM'"
                    :file-type="'xlsx'" :sheet-name="'history'">
                    <v-icon large color="green">mdi-file-excel</v-icon>
                  </vue-excel-xlsx>
                </v-col>
              </v-card-title>
              <v-card-text class="mt-5">
                <v-data-table :items="meterKMdatas" :headers="headerMeterTable" :items-per-page="5" dense>
                  <template v-slot:[`item.readingdate`]="{ item }">
                    {{ formatdate(item.readingdate) }}
                  </template>
                  <template v-slot:[`item.readingsource`]="{ item }">
                    {{ getSource(item.readingsource) }}
                  </template>
                </v-data-table>
              </v-card-text>
            </v-card>
          </v-col>
          <v-col>
            <v-card ref="hmHistory" class="mb-3">
              <v-card-title class="portal-deep-blue-bg">
                {{ $t("message.infoloc.hhm", { value: "default" }) }}
                <v-col align="right" class="py-0">
                  <vue-excel-xlsx :data="meterHMdatas" :columns="getExportColumns" :file-name="'history_HM'"
                    :file-type="'xlsx'" :sheet-name="'history'">
                    <v-icon large color="green">mdi-file-excel</v-icon>
                  </vue-excel-xlsx>
                </v-col>
              </v-card-title>
              <v-card-text class="mt-5">
                <v-data-table :items="meterHMdatas" :headers="headerMeterTable" :items-per-page="5" dense>
                  <template v-slot:[`item.readingdate`]="{ item }">
                    {{ formatdate(item.readingdate) }}
                  </template>
                  <template v-slot:[`item.readingsource`]="{ item }">
                    {{ getSource(item.readingsource) }}
                  </template>
                </v-data-table>
              </v-card-text>
            </v-card>
          </v-col>
        </v-row>

        <v-card class="mb-3">
          <v-card-title class="portal-deep-blue-bg">
            {{ $t("message.infoloc.wheelset", { value: "default" }) }}
          </v-card-title>
          <v-card-text>
            <div class="text-subtitle-2 my-2">
              <b>{{ $t("message.magic.date", { value: "default" }) }}:
                {{ wheelsets[0]?.measuredate }}</b>
            </div>
            <v-row class="mt-5 ">

              <v-col class="text-center d-flex justify-center">
                <v-sheet width="300" class="mx-3">

                  <div class="d-flex flex-column wheel">
                    <!-- wheel measure right -->
                    <v-card class="mb-auto" color="rgba(255, 255, 255, 0)" elevation="0">
                      <v-row>
                        <v-col class="schema-text text-left">
                          R:{{ wheelsets[0]?.measures[wheelsetsNums[0]]?.dright }}
                        </v-col>
                        <v-col class="schema-text text-right">
                          R:{{ wheelsets[0]?.measures[wheelsetsNums[1]]?.dright }}
                        </v-col>
                      </v-row>
                    </v-card>

                    <!--wheel nums-->
                    <v-card class="mb-auto" color="rgba(255, 255, 255, 0)" elevation="0">
                      <v-row>
                        <v-col class="schema-text text-left pl-7">
                          <b>{{ wheelsetsNums[0] }}</b>
                        </v-col>
                        <v-col class="schema-text">
                          <b>{{ wheelsetsNums[1] }}</b>
                        </v-col>
                      </v-row>
                    </v-card>

                    <!-- wheel measure left -->
                    <v-card color="rgba(255, 255, 255, 0)" elevation="0">
                      <v-row>
                        <v-col class="schema-text text-left">
                          L:{{ wheelsets[0]?.measures[wheelsetsNums[0]]?.dleft }}
                        </v-col>
                        <v-col class="schema-text text-right">
                          L:{{ wheelsets[0]?.measures[wheelsetsNums[1]]?.dleft }}
                        </v-col>
                      </v-row>
                    </v-card>
                  </div>
                  <img src="@/assets/wheels.png" height="200" alt="logo" style="display: block; margin: auto; " />
                </v-sheet>
              </v-col>
              <v-col class="text-center d-flex justify-center">
                <v-sheet width="300" class="mx-3">

                  <div class="d-flex flex-column wheel">
                    <!-- wheel measure right -->
                    <v-card class="mb-auto" color="rgba(255, 255, 255, 0)" elevation="0">
                      <v-row>
                        <v-col class="schema-text text-left">
                          R:{{ wheelsets[0]?.measures[wheelsetsNums[2]]?.dright }}
                        </v-col>
                        <v-col class="schema-text text-right">
                          R:{{ wheelsets[0]?.measures[wheelsetsNums[3]]?.dright }}
                        </v-col>
                      </v-row>
                    </v-card>
                    <!--wheel nums-->
                    <v-card class="mb-auto" color="rgba(255, 255, 255, 0)" elevation="0">
                      <v-row>
                        <v-col class="schema-text text-left pl-7">
                          <b>{{ wheelsetsNums[2] }}</b>
                        </v-col>
                        <v-col class="schema-text">
                          <b>{{ wheelsetsNums[3] }}</b>
                        </v-col>
                      </v-row>
                    </v-card>

                    <!-- wheel measure left -->
                    <v-card color="rgba(255, 255, 255, 0)" elevation="0">
                      <v-row>
                        <v-col class="schema-text text-left">
                          L:{{ wheelsets[0]?.measures[wheelsetsNums[2]]?.dleft }}
                        </v-col>
                        <v-col class="schema-text text-right">
                          L:{{ wheelsets[0]?.measures[wheelsetsNums[3]]?.dleft }}
                        </v-col>
                      </v-row>
                    </v-card>
                  </div>

                  <img src="@/assets/wheels.png" height="200" alt="logo" style="display: block; margin: auto; " />

                </v-sheet>
              </v-col>

            </v-row>
          </v-card-text>

        </v-card>

        <v-card class="mb-3">

          <v-card-title class="portal-deep-blue-bg">
            {{ $t("message.aside.history", { value: "default" }) }}
          </v-card-title>
          <v-card-text>
            <v-row class="text-center">
              <v-col>
                <v-data-table :items="wheelsets" :items-per-page="5" dense class="mt-3">
                  <template v-slot:header="{ props: {} }">
                    <thead>
                      <tr>
                        <th>&nbsp;</th>
                        <template v-for="wheel in wheelsetsNums">
                          <th style="cursor: pointer" :key="wheel.concat('-', 'left')">
                            D LEFT
                          </th>
                          <th style="cursor: pointer" :key="wheel.concat('-', 'right')">
                            D RIGHT
                          </th>
                        </template>
                      </tr>
                    </thead>
                  </template>
                  <template v-slot:body="{ items }">
                    <tbody>
                      <tr v-for="item in items" :key="item.measuredate">
                        <td>{{ item?.measuredate }}</td>
                        <td>{{ item?.measures[wheelsetsNums[0]]?.dleft }}</td>
                        <td>
                          {{ item?.measures[wheelsetsNums[0]]?.dright }}
                        </td>
                        <td>{{ item?.measures[wheelsetsNums[1]]?.dleft }}</td>
                        <td>{{ item?.measures[wheelsetsNums[1]]?.dright }}</td>
                        <td>{{ item?.measures[wheelsetsNums[2]]?.dleft }}</td>
                        <td>{{ item?.measures[wheelsetsNums[2]]?.dright }}</td>
                        <td>{{ item?.measures[wheelsetsNums[3]]?.dleft }}</td>
                        <td>{{ item?.measures[wheelsetsNums[3]]?.dright }}</td>
                        <td>
                          <v-icon v-if="checkWo(item)" @click="downloadProtocol(item)">mdi-eye</v-icon>
                        </td>
                      </tr>
                    </tbody>
                  </template>
                </v-data-table>
              </v-col>
            </v-row>
          </v-card-text>
        </v-card>
      </div>
      <!-- loader-->
      <portal-loading :show="loading"></portal-loading>

      <!-- sign dialog-->
      <v-dialog v-model="showSign" width="700" scrollable overlay-color="#fff" overlay-opacity="0.5">
        <v-card outlined tile style="border: 2px solid #00475a" class="px-5">
          <v-system-bar height="30" color="#fff" class="px-0 mb-3">
            <span></span>
            <v-spacer></v-spacer>
            <v-icon size="32" class="pt-5" @click="showSign = false">mdi-close</v-icon>
          </v-system-bar>
          <sr-info :attachments="attachments" :sr="sr"></sr-info>
        </v-card>
      </v-dialog>

      <!-- measurement dialog-->
      <v-dialog v-model="showWheel" width="700" scrollable overlay-color="#fff" overlay-opacity="0.5">
        <v-card outlined tile style="border: 2px solid #00475a" class="px-5">
          <v-system-bar height="30" color="#fff" class="px-0 mb-3">
            <span></span>
            <v-spacer></v-spacer>
            <v-icon size="32" class="pt-5" @click="showWheel = false">mdi-close</v-icon>
          </v-system-bar>
          <v-row>
            <v-col>
              <div>
                <span class="mtitle">
                  Wheelset measurements
                </span>
              </div>
              <v-data-table dense :headers="headersProtocol" :items="wheelmeasurements" light>
                <template v-slot:[`item.createdate`]="{ item }">
                  {{ formatdate(item.createdate) }}
                </template>
                <template v-slot:[`item.document`]="{ item }" @click="downloadProtocol(item)">
                  {{ item.documentName }}

                  <v-icon @click="downloadProtocol(item)"> mdi-download</v-icon>
                </template>
              </v-data-table>
            </v-col>
          </v-row>
        </v-card>
      </v-dialog>

    </div>
  </v-app>
</template>

<script>
import PortalSysbar from "@/components/PortalSysbar";
import PortalAside from "@/components/PortalAside";
import PortalTitle from "@/components/PortalTitle";
import PortalBreadcumb from "@/components/PortalBreadcumb";
import MaximoService from "@/services/MaximoService";
import { formatMagicDate, getDefaultPeriod } from "@/shared/DateHelper";
import { getSrStatusText } from "@/shared/Helper";
import SrInfo from "@/components/SrInfo.vue";
import PortalLoading from "@/components/PortalLoading.vue";
import { mapGetters, mapActions } from "vuex";

export default {
  watch: {
    getterCurrentClient() {
      this.initAssetList();
    },
  },
  methods: {
    ...mapActions("carpet", {
      actionGetAssets: "loadAssets"
    }),

    async initAssetList() {
      await this.actionGetAssets({
          customer: this.getterCurrentClient, 
          start:getDefaultPeriod().start, 
          end: getDefaultPeriod().end 
    });
      this.assets = this.getterAssets.filter(elt => (elt.leasedState == "leased"));
      this.assetList = this.assets;
      this.assetList.forEach(a => {
        if([
      "MGW000",
      "MGWF",
      "MGWF-1",
      "AKIEM SAS",
      "MGWHU"
        ].includes(a.ecmCode)){
          a.ecmName = "AKIEM MAINTENANCE & SERVICES";
        }
      });

      this.ecmList = this.assetList.map(a => ({
        company: a.ecmCode,
        name: a.ecmName
      }));
    },

    filterByEcm(value) {
      this.assetList = this.assets.filter((item) => item.ecmCode == value)
    },

    async showSrDetails(id) {
      this.sr = this.srs.find((e) => e.ticketid == id);
      await MaximoService.getAttachments(this.sr.ticketuid)
        .then((response) => {
          this.attachments = response.data;
          this.showAttachment = true;
        })
        .catch(() => {
          this.showAttachment = false;
        });
      this.showSign = true;
    },

    async showMeasurementDetails(id) {
      await MaximoService.getDoclinksWheelset(id)
        .then((response) => {
          this.wheelmeasurements = response.data;
          this.showWheelmeasurements = true;
        })
        .catch(() => {
          this.wheelmeasurements = [];
          this.showWheelmeasurements = false;
        });
      this.showWheel = true;
    },

    getMemo(asset) {
      if (this.status.includes(asset.status)) {
        MaximoService.getStatusMemo(asset.assetid, asset.status).then(
          (response) => {
            this.remark = response.data.memo;
            this.loading = false
          }
        ).catch(() => {
          this.loading = false
        });
      } else {
        this.remark = "";
      }
    },
    async getAsset(assetnum) {
      this.loading = true
      MaximoService.getAssetByAssetnum(assetnum).then((response) => {
        this.asset = response.data;
        if (this.asset.workorder != null) {
          this.workorder = this.asset.workorder;
          this.workorder.location = this.workorder.location?.location;
        }
        this.getMemo(this.asset.asset);
      });
    },

    downloadProtocol(item) {
      let file_path = MaximoService.downloadProtocol(item.doclinksid);
      window.open(file_path);
    },

    //show sr status
    getSrStatusText(state) {
      return this.$t(getSrStatusText(state), { value: "default" });
    },

    getNextMaintenancePlan(assetnum) {
      MaximoService.getNextMaintenancePlan(assetnum).then((response) => {
        this.calcduedate = response.data.calcduedate;
        this.pleft = response.data.pleft;
      }).catch(() => {
        this.calcduedate = "";
        this.pleft = "";
      });
    },

    formatdate(date) {
      return formatMagicDate(date, this.$i18n.locale);
    },

    checkWo(item) {
      if (item?.doclinksid != null) {
        return true
      }
      return false
    },

    getWheelsetMeasurement(assetnum) {
      MaximoService.getWheelsetMeasureDates(assetnum).then((response) => {
        this.wheelsets = response.data;
        //this.getWheelsetsDoclinks();
      }).catch(() => {
        this.wheelsets = [];
      });
    },

    getWheelsetsDoclinks() {
      MaximoService.getDoclinksWheelsets(this.wheelsets.map(w => w.measures[0].measures[0].workorderid).filter(w => w != null)).then((response) => {
        this.wheelsetsDoclinks = response.data;
      }).catch(() => {
        this.wheelsetsDoclinks = [];
      });
    },

    hasDocLinkMeasurment(workorderid) {
      return this.wheelsetsDoclinks.filter(d => d.ownerid == workorderid).length != 0;
    },

    buildItems(data) {
      data.forEach((item) => {
        this.items.push({
          step: item.plusc,
          info: item.description,
        });
      });
    },

    getMeterdatas(assetnum) {
      MaximoService.getMeterdataByAsset(assetnum).then((response) => {
        this.meterKMdatas = response.data.filter(m => m.metername == "MILEAGE");
        this.meterHMdatas = response.data.filter(m => m.metername == "H0URS");
      });
    },
    getLastHM(assetnum) {
      MaximoService.getLastMeter(assetnum, "H0URS").then((response) => {
        this.lastHM = response.data;
      });
    },
    getLastKM(assetnum) {
      MaximoService.getLastMeter(assetnum, "MILEAGE").then((response) => {
        this.lastKM = response.data;
      });
    },
    getColor() {
      return "#00475a";
    },
    goToHistory(ref) {
      this.$refs[ref].$el.scrollIntoView();
    },
    getSource(readingsource) {
      return readingsource == "CX_INTSAGE" ? this.$t("message.pageHm.portalReal", { value: "default" }) : this.$t("message.pageHm.maintenanceReal", { value: "default" });
    },
    getPmWorkorders(assetnum) {
      MaximoService.getAssetPMWorkorders(assetnum).then((response) => {
        this.buildItems(response.data);
      });
    },
    getHomologations(assetnum) {
      MaximoService.getAssetHomologation(assetnum).then((response) => {
        this.homologations = response.data;
      });
    },

    getOpenSr(assetnum) {
      let scope = "internal";
      if (this.getterContact.internal) {
        scope = "internal";
      } else {
        scope = "external";
      }
      MaximoService.getOpenSrByAsset(scope, assetnum).then((response) => {
        this.srs = response.data;
      });
    },

    getWorkorder(assetnum) {
      MaximoService.getLastWorkorderByAssetnum(assetnum).then((response) => {
        this.workorder = response.data;
        MaximoService.getLocation(this.workorder.location).then((response) => [
          (this.asset.location = response.data.description),
        ]);
      });
    },
    getWheelSet(assetnum) {
      MaximoService.getWheelsets(assetnum).then(response => {
        this.wheelsetsNums = response.data
      }).catch(() => {
        this.wheelsetsNums = []
      })
    },

    loadData() {
      this.loading = true
      this.getAsset(this.selectedAsset);
      this.getNextMaintenancePlan(this.selectedAsset);
      this.getOpenSr(this.selectedAsset);
      this.getHomologations(this.selectedAsset);
      this.getWheelSet(this.selectedAsset)
      this.getWheelsetMeasurement(this.selectedAsset);
      this.getPmWorkorders(this.selectedAsset);
      this.getMeterdatas(this.selectedAsset);
      this.getLastHM(this.selectedAsset);
      this.getLastKM(this.selectedAsset);
      this.loading = false
    }
  },
  mounted() {
    this.selectedAsset = this.asset
    this.initAssetList();
    if (this.selectedAsset != undefined) {
      this.loadData()
    }

  },
  data() {
    return {
      assets: [],
      ecmList: [],
      assetList: [],
      remark: "",
      loading: false,
      status: ["CONDREL", "BLOCKED"],
      showAttachment: false,
      showSign: false,
      attachments: [],
      sr: {},
      calcduedate: "",
      pleft: "",
      search: "",
      srs: [],
      wheelsets: [],
      wheelsetsNums: [],
      wheelsetsDoclinks: [],
      wheelmeasurements: [],
      showWheelmeasurements: false,
      showWheel: false,
      items: [],
      homologations: [],
      meterHMdatas: [],
      meterKMdatas: [],
      workorder: {
        description: "--",
        targcompdate: "--",
        remarks: "--",
      },
      lastHM: false,
      lastKM: false,
    };
  },
  title: "",
  components: {
    PortalSysbar,
    PortalAside,
    PortalTitle,
    PortalBreadcumb,
    SrInfo,
    PortalLoading
  },
  computed: {
    headerSrTable() {
      return [{
        text: this.$t("message.magic.id", { value: "default" }),
        value: "ticketid",
        sortable: true,
      },
      {
        text: this.$t("message.magic.description", { value: "default" }),
        value: "title",
        sortable: true,
      },
      {
        text: this.$t("message.magic.status", { value: "default" }),
        value: "status",
        sortable: true,
      },
      {
        text: this.$t("message.magic.date", { value: "default" }),
        value: "reportdate",
        sortable: true,
      },
      {
        text: this.$t("message.magic.details", { value: "default" }),
        value: "action",
        sortable: false,
      },
      ];
    },

    headerMeterTable() {
      return [{
        text: this.$t("message.magic.date", { value: "default" }),
        value: "readingdate",
        sortable: true,
      },
      {
        text: this.$t("message.magic.meter", { value: "default" }),
        value: "reading",
        sortable: true,
      },
      {
        text: this.$t("message.magic.source", { value: "default" }),
        value: "readingsource",
        sortable: true,
      },
      ];
    },

    getExportColumns() {
      return [{
        label: this.$t("message.page.loconumber", { value: "default" }),
        field: "assetnum",
      },
      {
        label: this.$t("message.magic.date", { value: "default" }),
        field: "readingdate",
        dataFormat: this.formatdate
      },
      {
        label: this.$t("message.magic.meter", { value: "default" }),
        field: "reading",
      },
      {
        label: this.$t("message.magic.source", { value: "default" }),
        field: "readingsource",
        dataFormat: this.getSource
      },
      ];
    },

    headeWheelsetTable() {
      return [{
        text: this.$t("message.magic.date", { value: "default" }),
        value: "measuredate",
        sortable: true,
      },
      {
        text: "D1 / li",
        value: "measures.`wheelsetsNums.0`.dleft",
      },
      {
        text: "D1 / re",
        value: "measures.0.dright",
      },
      {
        text: "D2 / li",
        value: "measures.1.measures.1.measure",
      },
      {
        text: "D2 / re",
        value: "measures.1.measures.0.measure",
      },
      {
        text: "D3 / li",
        value: "measures.2.measures.1.measure",
      },
      {
        text: "D3 / re",
        value: "measures.2.measures.0.measure",
      },
      {
        text: "D4 / li",
        value: "measures.3.measures.1.measure",
      },
      {
        text: "D4 / re",
        value: "measures.3.measures.0.measure",
      },
      {
        text: "Details",
        value: "action",
        sortable: true,
      },
      ];
    },

    headersProtocol() {
      return [{
        text: this.$t("message.magic.date", { value: "default" }),
        value: "createdate",
      },
      {
        text: this.$t("message.magic.details", { value: "default" }),
        value: "document",
      },
      ];
    },

    ...mapGetters("auth", {
      getterCurrentClient: "getCurrentClient",
      getterContact: "getUserContact",
    }),

    ...mapGetters("carpet", {
      getterAssets: "getAssets"
    }),
  },

  props: ["asset"]
};
</script>

<style scoped>
.v-expansion-panel-header {
  color: #fff;
}

.portal-deep-blue-bg {
  padding: 5px 0px 5px 10px;
  color: #fff;
  text-transform: uppercase;
}

.dp {
  color: #00475a;
  font-weight: bolder;
}
.dp-gray.theme--light.v-data-table>.v-data-table__wrapper>table>tbody>tr>th.shrink {
    white-space:nowrap;
}

.dp-gray.theme--light.v-data-table>.v-data-table__wrapper>table>thead>tr>th {
  background-color: #c4c7c9;
  font-weight: bolder;
  color: #00475a;
  text-align: center;
}

.theme--light.v-data-table>.v-data-table__wrapper>table>thead>tr>th {
  color: rgba(0, 0, 0, 0.6);
  font-size: 12px;
  text-align: center;
}

.mtitle {
  color: #00475a;
  margin-bottom: 5px;
  margin-top: 20px;
  font-size: 14px;
}

.value {
  font-size: 16px;
}

.display-wheel {
  display: flex !important;
  justify-content: flex-start;
  align-items: baseline;
}

.schema-text {
  font-size: 10px;
}

.wheel {
  position: absolute;
  height: 200px;
  width: 300px;
}
</style>
